import { z } from 'zod';
import { ProdutoCategoriaSchema } from '@/features/produto-categoria/types/ProdutoCategoria';
import { ProdutoMarcaSelectSchema } from '@/features/produto-marca/types/ProdutoMarca';
import { SistemaLayoutSchema } from '@/features/sistema/types';
import { EmpresaSchema } from '../../empresa/types/Empresa';
import { EmpresaSlugSchema } from './EmpresaSlug';

export const EmpresaSlugSistemaSchema = z.object({
    layout: SistemaLayoutSchema,
    sis_base_url: z.string(),
    sis_facebook: z.string().nullable(),
    sis_icone: z.string().nullable(),
    sis_idpk: z.number(),
    sis_instagram: z.string().nullable(),
    sis_landing_page: z.string().nullable(),
    sis_logotipo: z.string().nullable(),
    sis_nome_sistema: z.string(),
    sis_titulo: z.string().nullable(),
    sis_youtube: z.string().nullable(),
});

export const EmpresaSlugEmpresaSchema = EmpresaSchema.pick({
    emp_cnpj_cpf: true,
    emp_email: true,
    emp_idpk: true,
    emp_logotipo_foto: true,
    emp_nome_fantasia: true,
    emp_nome_razaosocial: true,
    emp_telefone_principal: true,
}).extend({
    empresa_slug: EmpresaSlugSchema,
});

export const EmpresaSlugPublicoSchema = z.object({
    empresa: EmpresaSlugEmpresaSchema,
    produto_categoria: ProdutoCategoriaSchema.array().optional(),
    produto_marca: ProdutoMarcaSelectSchema.array().optional(),
    sistema: EmpresaSlugSistemaSchema,
    status: z.literal('sucesso'),
});
